var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMpWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Group_1511",
    width: 161.322,
    height: 30.628,
    "data-name": "Group 1511",
    viewBox: "0 0 161.322 30.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_526",
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_150",
    d: "M152.049 208.63a3.12 3.12 0 0 1-3.983 1.831 3.059 3.059 0 0 1-1.853-3.932l5.479-14.868a3.122 3.122 0 0 1 3.981-1.835 3.059 3.059 0 0 1 1.855 3.929z",
    className: "prefix__cls-1",
    "data-name": "Path 150",
    transform: "translate(-103.874 -189.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_151",
    d: "M39.175 230.821a3.12 3.12 0 0 1-3.981 1.836 3.061 3.061 0 0 1-1.855-3.931l6.265-17a3.117 3.117 0 0 1 3.981-1.834 3.053 3.053 0 0 1 1.855 3.93z",
    className: "prefix__cls-1",
    "data-name": "Path 151",
    transform: "translate(-33.151 -202.214)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_523",
    "data-name": "Group 523",
    transform: "translate(9.649 7.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_152",
    d: "M65.014 230.821a3.119 3.119 0 0 1-3.981 1.836 3.058 3.058 0 0 1-1.855-3.931l6.264-17a3.118 3.118 0 0 1 3.98-1.834 3.055 3.055 0 0 1 1.858 3.93z",
    className: "prefix__cls-1",
    "data-name": "Path 152",
    transform: "translate(-58.989 -209.706)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_524",
    "data-name": "Group 524",
    transform: "translate(19.294 7.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_153",
    d: "M90.84 230.821a3.116 3.116 0 0 1-3.979 1.836 3.055 3.055 0 0 1-1.854-3.931l6.265-17a3.115 3.115 0 0 1 3.978-1.834 3.053 3.053 0 0 1 1.856 3.93z",
    className: "prefix__cls-1",
    "data-name": "Path 153",
    transform: "translate(-84.817 -209.706)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_525",
    "data-name": "Group 525",
    transform: "translate(28.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_154",
    d: "M116.659 218.249a3.122 3.122 0 0 1-3.982 1.836 3.054 3.054 0 0 1-1.852-3.931l9.026-24.493a3.118 3.118 0 0 1 3.979-1.835 3.058 3.058 0 0 1 1.858 3.929z",
    className: "prefix__cls-1",
    "data-name": "Path 154",
    transform: "translate(-110.634 -189.642)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_530",
    "data-name": "Group 530",
    transform: "translate(59.96 10.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_527",
    "data-name": "Group 527",
    transform: "translate(97.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_155",
    d: "M457.807 216.791a1.686 1.686 0 1 1-1.69 1.678 1.673 1.673 0 0 1 1.69-1.678zm0 3.127a1.441 1.441 0 1 0-1.383-1.449 1.388 1.388 0 0 0 1.383 1.449zm-.652-2.427h.759c.465 0 .686.186.686.565a.507.507 0 0 1-.518.537l.562.87h-.331l-.53-.85h-.323v.85h-.3zm.3.873h.317c.271 0 .517-.013.517-.321 0-.261-.221-.306-.428-.306h-.406z",
    className: "prefix__cls-1",
    "data-name": "Path 155",
    transform: "translate(-456.117 -216.791)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_529",
    "data-name": "Group 529",
    transform: "translate(0 .17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_156",
    d: "M196.484 217.247l4.789 12.77 4.81-12.77h2.767v15.2h-1.915V219.8h-.043l-4.746 12.642h-1.724l-4.747-12.642h-.043v12.642h-1.915v-15.2z",
    className: "prefix__cls-1",
    "data-name": "Path 156",
    transform: "translate(-193.717 -217.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_157",
    d: "M250.054 239.006a2.56 2.56 0 0 1-1.3.277 1.558 1.558 0 0 1-1.117-.394 1.713 1.713 0 0 1-.415-1.288 4.333 4.333 0 0 1-1.735 1.288 5.992 5.992 0 0 1-3.554.223 3.279 3.279 0 0 1-1.16-.532 2.546 2.546 0 0 1-.777-.947 3.185 3.185 0 0 1-.287-1.415 3.234 3.234 0 0 1 .319-1.533 2.792 2.792 0 0 1 .841-.968 3.862 3.862 0 0 1 1.192-.564q.67-.192 1.373-.319.744-.148 1.415-.223a7.881 7.881 0 0 0 1.182-.213 1.966 1.966 0 0 0 .809-.4.987.987 0 0 0 .3-.777 1.81 1.81 0 0 0-.223-.958 1.538 1.538 0 0 0-.575-.553 2.339 2.339 0 0 0-.788-.255 5.944 5.944 0 0 0-.862-.064 3.826 3.826 0 0 0-1.916.437 1.851 1.851 0 0 0-.83 1.649h-1.809a3.906 3.906 0 0 1 .426-1.724 3.227 3.227 0 0 1 1.022-1.139 4.294 4.294 0 0 1 1.458-.628 7.715 7.715 0 0 1 1.756-.192 10.3 10.3 0 0 1 1.479.107 3.877 3.877 0 0 1 1.331.435 2.554 2.554 0 0 1 .958.924 2.955 2.955 0 0 1 .361 1.55v5.649a4.212 4.212 0 0 0 .075.935q.074.3.5.3a2.191 2.191 0 0 0 .553-.085zm-2.937-5.64a2.262 2.262 0 0 1-.894.371q-.553.117-1.16.19t-1.224.17a4.507 4.507 0 0 0-1.107.307 2.007 2.007 0 0 0-.8.6 1.684 1.684 0 0 0-.309 1.07 1.458 1.458 0 0 0 .181.752 1.5 1.5 0 0 0 .468.5 1.965 1.965 0 0 0 .67.275 3.717 3.717 0 0 0 .809.084 4.311 4.311 0 0 0 1.532-.243 3.226 3.226 0 0 0 1.043-.614 2.431 2.431 0 0 0 .6-.8 2.033 2.033 0 0 0 .192-.815z",
    className: "prefix__cls-1",
    "data-name": "Path 157",
    transform: "translate(-222.535 -223.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_158",
    d: "M273.614 228.045v1.745h.042a3.81 3.81 0 0 1 3.576-2 4.774 4.774 0 0 1 1.809.3 2.98 2.98 0 0 1 1.171.83 3.085 3.085 0 0 1 .628 1.266 6.827 6.827 0 0 1 .181 1.629v7.236h-1.808V231.6a2.186 2.186 0 0 0-.6-1.618 2.216 2.216 0 0 0-1.639-.6 3.685 3.685 0 0 0-1.437.255 2.7 2.7 0 0 0-1.011.724 3.119 3.119 0 0 0-.606 1.1 4.458 4.458 0 0 0-.2 1.373v6.215h-1.809v-11z",
    className: "prefix__cls-1",
    "data-name": "Path 158",
    transform: "translate(-242.711 -223.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_159",
    d: "M304.354 228.045v1.49h.043a2.708 2.708 0 0 1 1.4-1.33 5.243 5.243 0 0 1 2.107-.415 4.967 4.967 0 0 1 2.224.468 4.536 4.536 0 0 1 1.575 1.266 5.593 5.593 0 0 1 .947 1.841 7.511 7.511 0 0 1 .32 2.213 7.757 7.757 0 0 1-.309 2.213 5.213 5.213 0 0 1-.936 1.82 4.419 4.419 0 0 1-1.575 1.224 5.115 5.115 0 0 1-2.2.447 5.463 5.463 0 0 1-.9-.085 5.037 5.037 0 0 1-.99-.276 3.855 3.855 0 0 1-.926-.522 2.9 2.9 0 0 1-.734-.819h-.043v5.662h-1.809v-15.2zm6.5 3.906a4.043 4.043 0 0 0-.617-1.309 3.026 3.026 0 0 0-1.064-.915 3.238 3.238 0 0 0-1.522-.341 2.987 2.987 0 0 0-2.6 1.309 3.966 3.966 0 0 0-.586 1.33 6.445 6.445 0 0 0 .011 3.076 3.871 3.871 0 0 0 .607 1.33 3.094 3.094 0 0 0 1.075.926 3.355 3.355 0 0 0 1.6.351 3.088 3.088 0 0 0 1.564-.362 2.912 2.912 0 0 0 1.011-.958 4.188 4.188 0 0 0 .553-1.362 7.264 7.264 0 0 0 .17-1.575 5.625 5.625 0 0 0-.2-1.5z",
    className: "prefix__cls-1",
    "data-name": "Path 159",
    transform: "translate(-261.905 -223.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_160",
    d: "M334.089 231.291a5.123 5.123 0 0 1 1.022-1.83 4.81 4.81 0 0 1 1.682-1.224 6.161 6.161 0 0 1 4.608 0 4.836 4.836 0 0 1 1.67 1.224 5.135 5.135 0 0 1 1.022 1.83 7.339 7.339 0 0 1 .34 2.267 7.235 7.235 0 0 1-.34 2.256 5.15 5.15 0 0 1-1.022 1.82 4.711 4.711 0 0 1-1.67 1.213 6.3 6.3 0 0 1-4.608 0 4.687 4.687 0 0 1-1.682-1.213 5.137 5.137 0 0 1-1.022-1.82 7.223 7.223 0 0 1-.34-2.256 7.326 7.326 0 0 1 .34-2.267zm1.841 4.044a3.715 3.715 0 0 0 .734 1.3 3.184 3.184 0 0 0 1.1.8 3.335 3.335 0 0 0 2.66 0 3.185 3.185 0 0 0 1.1-.8 3.715 3.715 0 0 0 .734-1.3 6.065 6.065 0 0 0 0-3.554 3.84 3.84 0 0 0-.734-1.309 3.13 3.13 0 0 0-1.1-.809 3.336 3.336 0 0 0-2.66 0 3.128 3.128 0 0 0-1.1.809 3.84 3.84 0 0 0-.734 1.309 6.065 6.065 0 0 0 0 3.554z",
    className: "prefix__cls-1",
    "data-name": "Path 160",
    transform: "translate(-281.457 -223.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_161",
    d: "M373.937 239.478l-2.237-8.748h-.043l-2.213 8.747h-1.958l-3.533-11h2l2.49 9h.043l2.213-9h1.979l2.3 9h.043l2.469-9h1.873l-3.512 11z",
    className: "prefix__cls-1",
    "data-name": "Path 161",
    transform: "translate(-300.383 -224.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_162",
    d: "M414.538 238.347a5 5 0 0 1-3.108.936 5.656 5.656 0 0 1-2.288-.425 4.508 4.508 0 0 1-1.628-1.192 5.059 5.059 0 0 1-.99-1.83 8.783 8.783 0 0 1-.372-2.32 6.625 6.625 0 0 1 .383-2.3 5.5 5.5 0 0 1 1.075-1.809 4.88 4.88 0 0 1 1.639-1.192 5.01 5.01 0 0 1 2.076-.426 4.513 4.513 0 0 1 2.437.607 4.823 4.823 0 0 1 1.554 1.543 6.1 6.1 0 0 1 .809 2.043 8.766 8.766 0 0 1 .181 2.107h-8.237a4.377 4.377 0 0 0 .171 1.373 3.1 3.1 0 0 0 .617 1.149 3.042 3.042 0 0 0 1.086.8 3.741 3.741 0 0 0 1.553.3 3.131 3.131 0 0 0 1.884-.532 2.573 2.573 0 0 0 .968-1.618h1.788a4.4 4.4 0 0 1-1.598 2.786zm-.437-7.066a3.081 3.081 0 0 0-2.884-1.894 3.148 3.148 0 0 0-1.266.245 2.921 2.921 0 0 0-.969.67 3.211 3.211 0 0 0-.638.99 3.769 3.769 0 0 0-.277 1.2h6.321a3.72 3.72 0 0 0-.288-1.212z",
    className: "prefix__cls-1",
    "data-name": "Path 162",
    transform: "translate(-326.823 -223.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_163",
    d: "M440 228.041v2.32h.043a4.9 4.9 0 0 1 1.617-1.979 4.07 4.07 0 0 1 2.426-.6v1.918a5.114 5.114 0 0 0-1.851.3 2.921 2.921 0 0 0-1.234.873 3.6 3.6 0 0 0-.681 1.394 7.524 7.524 0 0 0-.213 1.884v4.895H438.3v-11z",
    className: "prefix__cls-1",
    "data-name": "Path 163",
    transform: "translate(-346.963 -223.849)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpWhite);
export default __webpack_public_path__ + "static/media/mp-white.bc88bf50b3224d95e3553b24f104d13d.svg";
export { ForwardRef as ReactComponent };